import React from 'react';
import { compose, hoistStatics } from 'recompose';
import { connect } from 'react-redux';
import FileService from '../services/file.service';

const mapStateToProps = state => ({
  preloader_image: state.settings.subscriber && state.settings.subscriber.preloader_image,
});

const enhance = compose(
  connect(mapStateToProps, null),
);

const Loading2 = ({ preloader_image }) => (
  <div className="center">
    {!!preloader_image && (
      <img className="img-preloader-center2" src={FileService.getFilenamePathById(preloader_image)} />
    )}
    {!preloader_image && (
      <div id="loading2">
        <div className="ripple ripple1" />
        <div className="ripple ripple2" />
        <div className="ripple ripple3" />
        <div className="ripple ripple4" />
      </div>
    )}
  </div>);

export default hoistStatics(enhance)(Loading2);




// WEBPACK FOOTER //
// ./src/components/Loading2.jsx